module.exports = __webpack_public_path__ + "34736292/img/saly-icon.39e12342.jpg";